<template>
  <div>
    <div class="logistics" v-if="newCartInfo.length != 0">
      <div
        class="header acea-row row-between row-top"
        v-for="(cart, inx) in newCartInfo"
        :key="cart.id"
        style="padding: 0.23rem 0.3rem;background-color: #fff;"
      >
        <!-- <template v-for="goods in cart.goods_info"> -->
        <div class="pictrue">
          <img :src="cart.goods_info.productInfo.image" />
        </div>
        <div class="text acea-row row-between">
          <div class="name line2">
            {{ cart.goods_info.productInfo.store_name }}
          </div>
          <div class="money">
            <!-- <div>{{ goods.truePrice }}点</div> -->
            <div>x{{ cart.goods_info.cart_num }}</div>
          </div>
        </div>
        <div
          v-if="cart.goods_info.productInfo.is_package == 1 && cart.is_show"
          class="logisticsListBox"
        >
          <LogisticsModul
            :data="cart.goods_info.productInfo.packages"
          ></LogisticsModul>
        </div>

        <!-- </template> -->
        <div class="logisticsCon">
          <div
            class="company acea-row row-between-wrapper"
            v-if="
              cart.is_package == 0 && cart.goods_info.productInfo.express != ''
            "
          >
            <div class="picTxt acea-row row-between-wrapper">
              <div class="iconfont icon-wuliu"></div>
              <div class="text">
                <div>
                  <span class="name line1">物流公司：{{cart.goods_info.productInfo.express.result.expName}}</span>
                </div>
                <div class="express line1">
                  <span class="name">快递单号：{{cart.goods_info.productInfo.express.result.number}}</span>
                </div>
              </div>
            </div>
            <div
              class="copy acea-row row-center-wrapper copy-data"
              :data-clipboard-text="
                cart.goods_info.productInfo.express.result.number
              "
            >
              复制单号
            </div>
          </div>

          <div>
            <div
              class="xq"
              @click="isshow(inx)"
              v-if="cart.goods_info.productInfo.express != ''"
              style="width:6.9rem; margin:0 auto;"
            >
              <span v-if="!cart.is_show">点击查看详情</span>
              <span class="down" v-if="!cart.is_show">︾</span>

              <span v-if="cart.is_show">收起</span>
              <span class="down" v-if="cart.is_show">︽</span>
            </div>
          </div>

          <div
            v-if="
              cart.goods_info.productInfo.packages.length == 0 &&
                cart.is_package == 0 &&
                cart.goods_info.productInfo.express != ''
            "
          >
            <div
              class="item xq"
              v-if="
                cart.goods_info.productInfo.express.status !== '0' &&
                  cart.goods_info.productInfo.express.result.list.length != 0
              "
            >
              :( 暂未查到与您单号相关的物流信息，请稍后再尝试。
            </div>

            <div
              class="item"
              v-else-if="cart.is_show"
              v-for="(express, index) in cart.goods_info.productInfo.express
                .result.list"
              :key="index"
            >
              <div class="circular" :class="index === 0 ? 'on' : ''"></div>
              <div class="text">
                <div :class="index === 0 ? 'font-color-red' : ''">
                  {{ express.status }}
                </div>
                <div class="data">{{ express.time }}</div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="
            cart.is_package == 1 &&
              cart.goods_info.productInfo.packages.length == 0 &&
              cart.goods_info.productInfo.express != ''
          "
        >
          <div class="logisticsCon">
            <div class="company acea-row row-between-wrapper">
              <div class="picTxt acea-row row-between-wrapper">
                <div class="iconfont icon-wuliu"></div>
                <div class="text">
                  <div>
                    <span class="name line1" style="width:100%;"
                      >此商品暂未发货，我们正在加紧处理</span
                    >
                  </div>
                  <div class="express line1">
                    <span class="name">再次深感抱歉，请您耐心等待</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--     <div class="logisticsCon">
            <div class="company acea-row row-between-wrapper">
        <div class="picTxt acea-row row-between-wrapper">
          <div class="iconfont icon-wuliu"></div>
          <div class="text">
            <div>
              <span class="name line1"
                >物流公司：{{ orderInfo.delivery_name }}</span
              >
            </div>
            <div class="express line1">
              <span class="name">快递单号：</span> {{ orderInfo.delivery_id }}
            </div>
          </div>
        </div>
        <div
          class="copy acea-row row-center-wrapper copy-data"
          :data-clipboard-text="orderInfo.delivery_id"
        >
          复制单号
        </div>
      </div>
    </div> -->
      <!--     <div class="logisticsCon">


    </div> -->
      <!-- <div class="no-express" v-if="loaded && !expressList.length">
      <img src="@assets/images/noExpress.png" />
    </div> -->
      <!-- <Recommend v-if="false"></Recommend> -->
    </div>
    <!-- <div v-else>

<div class="logistics">
    <div
      class="header acea-row row-between row-top"
      v-for="cart in cartInfo"
      :key="cart.id"
    >
      <div class="pictrue"><img :src="cart.productInfo.image" /></div>
      <div class="text acea-row row-between">
        <div class="name line2">
          {{ cart.productInfo.store_name }}
        </div>
        <div class="money">
          <div>{{ cart.truePrice }}点</div>
          <div>x{{ cart.cart_num }}</div>
        </div>
      </div>
    </div>
    <div class="logisticsCon">
      <div class="company acea-row row-between-wrapper">
        <div class="picTxt acea-row row-between-wrapper">
          <div class="iconfont icon-wuliu"></div>
          <div class="text">
            <div>
              <span class="name line1"
                >物流公司：{{ orderInfo.delivery_name }}</span
              >
            </div>
            <div class="express line1">
              <span class="name">快递单号：</span> {{ orderInfo.delivery_id }}
            </div>
          </div>
        </div>
        <div
          class="copy acea-row row-center-wrapper copy-data"
          :data-clipboard-text="orderInfo.delivery_id"
        >
          复制单号
        </div>
      </div>
      <div class="item" v-for="(express, index) in expressList" :key="index">
        <div class="circular" :class="index === 0 ? 'on' : ''"></div>
        <div class="text">
          <div :class="index === 0 ? 'font-color-red' : ''">
            {{ express.status }}
          </div>
          <div class="data">{{ express.time }}</div>
        </div>
      </div>
    </div>

    <Recommend v-if="false"></Recommend>
  </div>
    </div> -->
  </div>
</template>
<script>
import Recommend from "@components/Recommend";
import ClipboardJS from "clipboard";
import { express } from "@api/order";
import LogisticsModul from "./LogisticsModul";

const NAME = "Logistics";

export default {
  name: NAME,
  components: {
    Recommend,
    LogisticsModul
  },
  data: function() {
    return {
      id: this.$route.params.id,
      cartInfo: [],
      newCartInfo: [],
      orderInfo: {},
      expressList: [],
      loaded: false,
      is_show: false,
      lalalaal: [
        {
          id: 1
        }
      ]
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME && this.$route.params.id !== this.id) {
        this.id = this.$route.params.id;
        this.getExpress();
      }
    }
  },
  mounted: function() {
    this.getExpress();
  },
  methods: {
    isshow(index) {
      var that = this;
      var listData = that.newCartInfo;
      var is_show = that.newCartInfo[index].is_show; // 先用一个变量接收一个原来的状态值
      listData.forEach(item => {
        //循环已经把所有的状态值清空了
        item.is_show = false;
      });
      //(比如我当前点击的这个是打开的状态，他是true，点击的方法开始先把这个true存下来，然后接下来的循环是把所有的状态值设为false，如果你不存下来的话，你    ！状态值永远为true)
      listData[index].is_show = !is_show;
      that.newCartInfo = listData;
    },
    getExpress() {
      if (!this.id) return this.$dialog.error("订单不存在");
      this.loaded = false;
      express(this.id)
        .then(res => {
          // console.log(res, "订单详情物流信息");
          const result = res.data.express.result || {};
          this.cartInfo = res.data.order.cartInfo;

          var newCartInfo = res.data.order.newCartInfo; // 先用一个变量接收对象
          newCartInfo.forEach(item => {
            item.is_show = false; // 给一个对象赋值一个属性
          });

          this.newCartInfo = newCartInfo; // 把变量赋值给全局变量
          // console.log(this.newCartInfo, "newCartInfo");
          // this.newCartInfo = res.data.order.newCartInfo;
          this.orderInfo = res.data.order;
          this.expressList = result.list || [];
          this.loaded = true;

          //复制
          this.$nextTick(function() {
            var copybtn = document.getElementsByClassName("copy-data");
            const clipboard = new ClipboardJS(copybtn);
            clipboard.on("success", () => {
              this.$dialog.success("复制成功");
            });
          });
        })
        .catch(e => {
          this.$dialog.error(e.msg || "加载失败");
        });
    }
  }
};
</script>

<style scoped>
.logisticsListBox {
  background: rgba(255, 255, 255);
  box-sizing: border-box;
  margin: 0.3rem 0 0 0.5rem;
  /* border-left:.05rem solid #2374;
  border-top:.05rem solid #2374; */
}

.no-express {
  margin: 1.5rem 0;
}

.no-express img {
  width: 6rem;
  margin: 0 auto;
  display: block;
}

.active {
  display: none;
}
.xq {
  width: 100%;
  text-align: center;
  font-size: 0.2rem;
  color: #999;
  padding-bottom: 0.3rem;
  position: relative;
}
.down {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%);
}
</style>
